module.exports = __webpack_public_path__ + "static/media/BannerD8.c3e2c13e.png";